<template>
    <section class="collapsible-panel">
        <header class="collapsible-panel__header" @click="open = !open">
            <h2 class="collapsible-panel__title">
                {{ title }}
                <span v-if="required" class="collapsible-panel__required" aria-hidden="true">*</span>
            </h2>
            <button type="button" class="collapsible-panel__toggle" :aria-expanded="open ? 'true' : 'false'" :aria-label="title">
                <i class="i-andy-xs" :class="open ? 'i-andy-chevron-down' : 'i-andy-chevron-up'" aria-hidden="true"></i>
            </button>
        </header>
        <div v-show="open" class="collapsible-panel__content">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CollapsiblePanel',
    props: {
        title: { type: String, required: true },
        required: { type: Boolean, default: false },
        initiallyOpen: { type: Boolean, default: true }
    },
    data() {
        return {
            open: this.initiallyOpen
        }
    }
}
</script>

<style lang="scss" scoped>
.collapsible-panel {
    @include display-flex();
    @include flex-direction(column);
    gap: 8px;
    padding: 4px;
    background-color: $neutro-t90;

    &__header {
        @include display-flex();
        @include align-items(center);
        @include justify-content(space-between);
        @include border-radius(4px);
        cursor: pointer;
    }

    &__title {
        margin: 0;
        font-family: $text-bold;
        @include font-size(16px);
        line-height: 16px;
        color: $neutro-s80;
    }

    &__required {
        color: $error-dark;
    }

    &__toggle {
        position: relative;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        padding: 8px;
        border: none;
        @include border-radius(4px);
        background-color: $main-t90;
        color: $main-dark;
        cursor: pointer;

        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 44px;
            height: 44px;
            transform: translate(-50%, -50%);
        }
    }

    &__content {
        @include display-flex();
        @include flex-direction(column);
        gap: 8px;
    }
}
</style>
